module.exports = __webpack_public_path__ + "static/img/quality.cfefc77.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/quality.png
// module id = jOe8
// module chunks = 0